// extracted by mini-css-extract-plugin
export default {"wrapper":"order-acceptation_wrapper__+f3V5","opacity-transition":"order-acceptation_opacity-transition__VF5Qn"};